"use client";

import Cookies from "js-cookie";
import { useLocale } from "next-intl";
import { useEffect } from "react";

/**
 * This component is used to set the NEXT_LOCALE cookie to the current locale.
 * This is needed since we want to avoid setting cookies in the middleware,
 * because that makes those requests non-cacheable in our CDN.
 */
export default function LocaleCookieSetter() {
  const locale = useLocale();
  useEffect(() => {
    // This should signal the middleware that the page has successfully loaded,
    // and i18n redirect loops may be safely applied without causing a redirect loop
    Cookies.remove("NEXT_LOCALE_LAST_PATH");

    // Only set the cookie if it doesn't exist or if the value is different
    const existingCookie = Cookies.get("NEXT_LOCALE");
    const missingLocaleCookie = Cookies.get("NEXT_LOCALE_NO_SET");

    // If the MISSING_LOCALE cookie is set, we don't want to set the NEXT_LOCALE cookie
    if (missingLocaleCookie) {
      Cookies.remove("NEXT_LOCALE_NO_SET");
      return;
    }

    if (existingCookie !== locale) {
      Cookies.set("NEXT_LOCALE", locale, {
        path: "/",
        expires: 365, // 1 year
        secure: true,
        sameSite: "strict",
      });
    }
  }, [locale]);

  return null;
}
